export default __webpack_public_path__ + "static/media/personalise_img.aaef1378.png";